@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_144_847_346)
public val Res.string.onboarding_hours_invalid: StringResource by lazy {
      StringResource("string:onboarding_hours_invalid", "onboarding_hours_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201404, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285772, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183675, 72),
      ))
    }

@delegate:ResourceContentHash(1_106_232_936)
public val Res.string.onboarding_hours_later: StringResource by lazy {
      StringResource("string:onboarding_hours_later", "onboarding_hours_later", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201493, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285897, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183748, 54),
      ))
    }

@delegate:ResourceContentHash(-1_821_138_700)
public val Res.string.onboarding_hours_opens: StringResource by lazy {
      StringResource("string:onboarding_hours_opens", "onboarding_hours_opens", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201556, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285980, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183803, 38),
      ))
    }

@delegate:ResourceContentHash(-1_564_904_980)
public val Res.string.onboarding_hours_preview: StringResource by lazy {
      StringResource("string:onboarding_hours_preview", "onboarding_hours_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201599, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286035, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183842, 60),
      ))
    }

@delegate:ResourceContentHash(-58_225_802)
public val Res.string.onboarding_hours_title: StringResource by lazy {
      StringResource("string:onboarding_hours_title", "onboarding_hours_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201660, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286108, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183903, 54),
      ))
    }

@delegate:ResourceContentHash(-891_872_128)
public val Res.string.onboarding_invite_code_label: StringResource by lazy {
      StringResource("string:onboarding_invite_code_label", "onboarding_invite_code_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201743, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286199, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183958, 56),
      ))
    }

@delegate:ResourceContentHash(2_094_401_771)
public val Res.string.onboarding_invite_code_placeholder: StringResource by lazy {
      StringResource("string:onboarding_invite_code_placeholder", "onboarding_invite_code_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201800, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286272, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184015, 62),
      ))
    }

@delegate:ResourceContentHash(165_637_979)
public val Res.string.onboarding_join_check: StringResource by lazy {
      StringResource("string:onboarding_join_check", "onboarding_join_check", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201855, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286347, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184078, 49),
      ))
    }

@delegate:ResourceContentHash(1_642_435_605)
public val Res.string.onboarding_join_confirm: StringResource by lazy {
      StringResource("string:onboarding_join_confirm", "onboarding_join_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201901, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286413, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184128, 43),
      ))
    }

@delegate:ResourceContentHash(109_044_067)
public val Res.string.onboarding_join_desc: StringResource by lazy {
      StringResource("string:onboarding_join_desc", "onboarding_join_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201953, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286485, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184172, 132),
      ))
    }

@delegate:ResourceContentHash(182_569_358)
public val Res.string.onboarding_join_title: StringResource by lazy {
      StringResource("string:onboarding_join_title", "onboarding_join_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202058, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286642, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184305, 49),
      ))
    }

@delegate:ResourceContentHash(-767_589_237)
public val Res.string.onboarding_market: StringResource by lazy {
      StringResource("string:onboarding_market", "onboarding_market", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202336, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287072, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184567, 33),
      ))
    }

@delegate:ResourceContentHash(749_778_997)
public val Res.string.onboarding_market_desc: StringResource by lazy {
      StringResource("string:onboarding_market_desc", "onboarding_market_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202116, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 286728, 294),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184355, 170),
      ))
    }

@delegate:ResourceContentHash(971_814_289)
public val Res.string.onboarding_market_poland: StringResource by lazy {
      StringResource("string:onboarding_market_poland", "onboarding_market_poland", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202295, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287023, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184526, 40),
      ))
    }

@delegate:ResourceContentHash(1_690_575_165)
public val Res.string.onboarding_next: StringResource by lazy {
      StringResource("string:onboarding_next", "onboarding_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202370, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287114, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184601, 35),
      ))
    }

@delegate:ResourceContentHash(1_628_059_152)
public val Res.string.onboarding_review_defaults_desc: StringResource by lazy {
      StringResource("string:onboarding_review_defaults_desc", "onboarding_review_defaults_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202402, 155),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287150, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184637, 151),
      ))
    }

@delegate:ResourceContentHash(-245_820_489)
public val Res.string.onboarding_review_defaults_title: StringResource by lazy {
      StringResource("string:onboarding_review_defaults_title", "onboarding_review_defaults_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202558, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287378, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184789, 60),
      ))
    }

@delegate:ResourceContentHash(304_397_110)
public val Res.string.onboarding_review_edit: StringResource by lazy {
      StringResource("string:onboarding_review_edit", "onboarding_review_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202631, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287475, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184850, 42),
      ))
    }

@delegate:ResourceContentHash(-615_280_501)
public val Res.string.onboarding_review_no_sales_plan: StringResource by lazy {
      StringResource("string:onboarding_review_no_sales_plan", "onboarding_review_no_sales_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202678, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287542, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184893, 95),
      ))
    }

@delegate:ResourceContentHash(-757_300_127)
public val Res.string.onboarding_review_settings_hint: StringResource by lazy {
      StringResource("string:onboarding_review_settings_hint", "onboarding_review_settings_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202778, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287682, 267),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184989, 179),
      ))
    }

@delegate:ResourceContentHash(672_462_811)
public val Res.string.onboarding_review_workplace_title: StringResource by lazy {
      StringResource("string:onboarding_review_workplace_title", "onboarding_review_workplace_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 202958, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 287950, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185169, 69),
      ))
    }

@delegate:ResourceContentHash(479_659_326)
public val Res.string.onboarding_role_join: StringResource by lazy {
      StringResource("string:onboarding_role_join", "onboarding_role_join", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203118, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288186, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185337, 48),
      ))
    }

@delegate:ResourceContentHash(-1_762_826_726)
public val Res.string.onboarding_role_join_desc: StringResource by lazy {
      StringResource("string:onboarding_role_join_desc", "onboarding_role_join_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203028, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288040, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185239, 97),
      ))
    }

@delegate:ResourceContentHash(-690_638_632)
public val Res.string.onboarding_role_owner: StringResource by lazy {
      StringResource("string:onboarding_role_owner", "onboarding_role_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203274, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288426, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185501, 53),
      ))
    }

@delegate:ResourceContentHash(-964_095_309)
public val Res.string.onboarding_role_owner_desc: StringResource by lazy {
      StringResource("string:onboarding_role_owner_desc", "onboarding_role_owner_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203167, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288263, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185386, 114),
      ))
    }

@delegate:ResourceContentHash(-428_622_699)
public val Res.string.onboarding_role_title: StringResource by lazy {
      StringResource("string:onboarding_role_title", "onboarding_role_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203328, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288500, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185555, 65),
      ))
    }

@delegate:ResourceContentHash(-2_103_114_995)
public val Res.string.onboarding_shift_evening: StringResource by lazy {
      StringResource("string:onboarding_shift_evening", "onboarding_shift_evening", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203406, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288602, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185621, 44),
      ))
    }

@delegate:ResourceContentHash(1_376_777_341)
public val Res.string.onboarding_shift_full_day: StringResource by lazy {
      StringResource("string:onboarding_shift_full_day", "onboarding_shift_full_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203451, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288655, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185666, 45),
      ))
    }

@delegate:ResourceContentHash(-1_592_874_178)
public val Res.string.onboarding_shift_morning: StringResource by lazy {
      StringResource("string:onboarding_shift_morning", "onboarding_shift_morning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203501, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288717, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185712, 44),
      ))
    }

@delegate:ResourceContentHash(-1_481_229_709)
public val Res.string.onboarding_skip: StringResource by lazy {
      StringResource("string:onboarding_skip", "onboarding_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203542, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288770, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185757, 39),
      ))
    }

@delegate:ResourceContentHash(1_074_547_896)
public val Res.string.onboarding_step_business: StringResource by lazy {
      StringResource("string:onboarding_step_business", "onboarding_step_business", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203586, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288834, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185797, 52),
      ))
    }

@delegate:ResourceContentHash(710_074_763)
public val Res.string.onboarding_step_counter: StringResource by lazy {
      StringResource("string:onboarding_step_counter", "onboarding_step_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203635, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288903, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185850, 55),
      ))
    }

@delegate:ResourceContentHash(-1_592_937_658)
public val Res.string.onboarding_step_done: StringResource by lazy {
      StringResource("string:onboarding_step_done", "onboarding_step_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203691, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 288963, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185906, 36),
      ))
    }

@delegate:ResourceContentHash(-1_902_735_166)
public val Res.string.onboarding_step_finance: StringResource by lazy {
      StringResource("string:onboarding_step_finance", "onboarding_step_finance", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203728, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289008, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185943, 47),
      ))
    }

@delegate:ResourceContentHash(-1_369_491_278)
public val Res.string.onboarding_step_hours: StringResource by lazy {
      StringResource("string:onboarding_step_hours", "onboarding_step_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203780, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289076, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185991, 49),
      ))
    }

@delegate:ResourceContentHash(182_569_358)
public val Res.string.onboarding_step_join: StringResource by lazy {
      StringResource("string:onboarding_step_join", "onboarding_step_join", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203834, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289142, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186041, 48),
      ))
    }

@delegate:ResourceContentHash(1_777_870_351)
public val Res.string.onboarding_step_role: StringResource by lazy {
      StringResource("string:onboarding_step_role", "onboarding_step_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203891, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289227, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186090, 40),
      ))
    }

@delegate:ResourceContentHash(1_273_520_969)
public val Res.string.onboarding_step_welcome: StringResource by lazy {
      StringResource("string:onboarding_step_welcome", "onboarding_step_welcome", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203936, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289280, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186131, 43),
      ))
    }

@delegate:ResourceContentHash(-226_903_731)
public val Res.string.onboarding_step_workplace: StringResource by lazy {
      StringResource("string:onboarding_step_workplace", "onboarding_step_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 203980, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289332, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186175, 53),
      ))
    }

@delegate:ResourceContentHash(-897_816_997)
public val Res.string.onboarding_summary_plan: StringResource by lazy {
      StringResource("string:onboarding_summary_plan", "onboarding_summary_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204034, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289402, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186229, 47),
      ))
    }

@delegate:ResourceContentHash(1_092_634_998)
public val Res.string.onboarding_summary_shifts: StringResource by lazy {
      StringResource("string:onboarding_summary_shifts", "onboarding_summary_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204082, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289458, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186277, 61),
      ))
    }

@delegate:ResourceContentHash(-1_932_778_234)
public val Res.string.onboarding_summary_workplace: StringResource by lazy {
      StringResource("string:onboarding_summary_workplace", "onboarding_summary_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204148, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289540, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186339, 60),
      ))
    }

@delegate:ResourceContentHash(-736_046_918)
public val Res.string.onboarding_tagline: StringResource by lazy {
      StringResource("string:onboarding_tagline", "onboarding_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204205, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289617, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186400, 110),
      ))
    }

@delegate:ResourceContentHash(-2_092_995_567)
public val Res.string.onboarding_welcome_desc: StringResource by lazy {
      StringResource("string:onboarding_welcome_desc", "onboarding_welcome_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204328, 199),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 289828, 319),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186511, 175),
      ))
    }

@delegate:ResourceContentHash(-2_100_741_963)
public val Res.string.onboarding_welcome_point_costs: StringResource by lazy {
      StringResource("string:onboarding_welcome_point_costs", "onboarding_welcome_point_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204528, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290148, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186687, 86),
      ))
    }

@delegate:ResourceContentHash(1_203_886_607)
public val Res.string.onboarding_welcome_point_rosters: StringResource by lazy {
      StringResource("string:onboarding_welcome_point_rosters", "onboarding_welcome_point_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204627, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290287, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186774, 92),
      ))
    }

@delegate:ResourceContentHash(1_028_078_743)
public val Res.string.onboarding_welcome_point_team: StringResource by lazy {
      StringResource("string:onboarding_welcome_point_team", "onboarding_welcome_point_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204732, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290428, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186867, 105),
      ))
    }

@delegate:ResourceContentHash(13_673_207)
public val Res.string.onboarding_welcome_title: StringResource by lazy {
      StringResource("string:onboarding_welcome_title", "onboarding_welcome_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204850, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290610, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186973, 60),
      ))
    }

@delegate:ResourceContentHash(-1_163_492_809)
public val Res.string.onboarding_workplace_desc: StringResource by lazy {
      StringResource("string:onboarding_workplace_desc", "onboarding_workplace_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 204907, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290679, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187034, 125),
      ))
    }

@delegate:ResourceContentHash(1_577_117_870)
public val Res.string.onboarding_workplace_title: StringResource by lazy {
      StringResource("string:onboarding_workplace_title", "onboarding_workplace_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205045, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290881, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187160, 62),
      ))
    }

@delegate:ResourceContentHash(-1_407_164_600)
public val Res.string.one_off_cost_add: StringResource by lazy {
      StringResource("string:one_off_cost_add", "one_off_cost_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205108, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 290964, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187223, 60),
      ))
    }

@delegate:ResourceContentHash(-1_267_800_926)
public val Res.string.one_off_cost_amount: StringResource by lazy {
      StringResource("string:one_off_cost_amount", "one_off_cost_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205185, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291065, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187284, 51),
      ))
    }

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.one_off_cost_day: StringResource by lazy {
      StringResource("string:one_off_cost_day", "one_off_cost_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205293, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291185, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187392, 28),
      ))
    }

@delegate:ResourceContentHash(1_274_841_543)
public val Res.string.one_off_cost_days_range: StringResource by lazy {
      StringResource("string:one_off_cost_days_range", "one_off_cost_days_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205237, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291129, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187336, 55),
      ))
    }

@delegate:ResourceContentHash(483_469_542)
public val Res.string.one_off_cost_delete_confirm: StringResource by lazy {
      StringResource("string:one_off_cost_delete_confirm", "one_off_cost_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205326, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291222, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187421, 83),
      ))
    }

@delegate:ResourceContentHash(-566_693_769)
public val Res.string.one_off_cost_deleted: StringResource by lazy {
      StringResource("string:one_off_cost_deleted", "one_off_cost_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205414, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291330, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187505, 40),
      ))
    }

@delegate:ResourceContentHash(872_948_359)
public val Res.string.one_off_cost_edit_title: StringResource by lazy {
      StringResource("string:one_off_cost_edit_title", "one_off_cost_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205459, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291383, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187546, 71),
      ))
    }

@delegate:ResourceContentHash(859_177_725)
public val Res.string.one_off_cost_from: StringResource by lazy {
      StringResource("string:one_off_cost_from", "one_off_cost_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205543, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291503, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187618, 33),
      ))
    }

@delegate:ResourceContentHash(1_380_928_483)
public val Res.string.one_off_cost_name_hint: StringResource by lazy {
      StringResource("string:one_off_cost_name_hint", "one_off_cost_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205581, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291541, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187652, 86),
      ))
    }

@delegate:ResourceContentHash(-248_409_161)
public val Res.string.one_off_cost_none: StringResource by lazy {
      StringResource("string:one_off_cost_none", "one_off_cost_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205684, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291700, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187739, 61),
      ))
    }

@delegate:ResourceContentHash(-1_013_474_684)
public val Res.string.one_off_cost_note: StringResource by lazy {
      StringResource("string:one_off_cost_note", "one_off_cost_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205786, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291806, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187801, 45),
      ))
    }

@delegate:ResourceContentHash(1_718_954_692)
public val Res.string.one_off_cost_period: StringResource by lazy {
      StringResource("string:one_off_cost_period", "one_off_cost_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205996, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292076, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187991, 35),
      ))
    }

@delegate:ResourceContentHash(-552_092_199)
public val Res.string.one_off_cost_period_day: StringResource by lazy {
      StringResource("string:one_off_cost_period_day", "one_off_cost_period_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205848, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291896, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187847, 43),
      ))
    }

@delegate:ResourceContentHash(1_560_861_519)
public val Res.string.one_off_cost_period_month: StringResource by lazy {
      StringResource("string:one_off_cost_period_month", "one_off_cost_period_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205896, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 291952, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187891, 49),
      ))
    }

@delegate:ResourceContentHash(1_696_235_961)
public val Res.string.one_off_cost_period_range: StringResource by lazy {
      StringResource("string:one_off_cost_period_range", "one_off_cost_period_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 205950, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292014, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187941, 49),
      ))
    }

@delegate:ResourceContentHash(-1_693_872_501)
public val Res.string.one_off_cost_saved: StringResource by lazy {
      StringResource("string:one_off_cost_saved", "one_off_cost_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206032, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292120, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188027, 34),
      ))
    }

@delegate:ResourceContentHash(1_327_318_602)
public val Res.string.one_off_cost_spread_hint: StringResource by lazy {
      StringResource("string:one_off_cost_spread_hint", "one_off_cost_spread_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206071, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292175, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188062, 96),
      ))
    }

@delegate:ResourceContentHash(-1_554_073_211)
public val Res.string.one_off_cost_to: StringResource by lazy {
      StringResource("string:one_off_cost_to", "one_off_cost_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206192, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292384, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188159, 27),
      ))
    }

@delegate:ResourceContentHash(-1_776_350_533)
public val Res.string.open_in_new_window: StringResource by lazy {
      StringResource("string:open_in_new_window", "open_in_new_window", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206228, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292424, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188187, 50),
      ))
    }

@delegate:ResourceContentHash(-2_116_141_419)
public val Res.string.over_plan_body: StringResource by lazy {
      StringResource("string:over_plan_body", "over_plan_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206496, 258),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292860, 410),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188459, 262),
      ))
    }

@delegate:ResourceContentHash(882_192_205)
public val Res.string.over_plan_body_no_bigger: StringResource by lazy {
      StringResource("string:over_plan_body_no_bigger", "over_plan_body_no_bigger", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206283, 212),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 292511, 348),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188238, 220),
      ))
    }

@delegate:ResourceContentHash(-1_983_378_725)
public val Res.string.over_plan_renewal: StringResource by lazy {
      StringResource("string:over_plan_renewal", "over_plan_renewal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206755, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 293271, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188722, 61),
      ))
    }

@delegate:ResourceContentHash(506_809_193)
public val Res.string.over_plan_title: StringResource by lazy {
      StringResource("string:over_plan_title", "over_plan_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206813, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 293353, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188784, 75),
      ))
    }

@delegate:ResourceContentHash(1_405_473_039)
public val Res.string.over_plan_upgrade: StringResource by lazy {
      StringResource("string:over_plan_upgrade", "over_plan_upgrade", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206881, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 293449, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188860, 61),
      ))
    }

@delegate:ResourceContentHash(-1_627_354_411)
public val Res.string.pay_change_line: StringResource by lazy {
      StringResource("string:pay_change_line", "pay_change_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 206935, 115),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 293523, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188922, 103),
      ))
    }

@delegate:ResourceContentHash(224_684_441)
public val Res.string.pay_change_salaried: StringResource by lazy {
      StringResource("string:pay_change_salaried", "pay_change_salaried", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207051, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 293663, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189026, 135),
      ))
    }

@delegate:ResourceContentHash(-851_340_881)
public val Res.string.payroll_below_minimum_hourly: StringResource by lazy {
      StringResource("string:payroll_below_minimum_hourly", "payroll_below_minimum_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207211, 144),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 293887, 232),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189162, 136),
      ))
    }

@delegate:ResourceContentHash(1_414_520_572)
public val Res.string.payroll_benefit_note: StringResource by lazy {
      StringResource("string:payroll_benefit_note", "payroll_benefit_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207356, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294120, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189299, 112),
      ))
    }

@delegate:ResourceContentHash(496_476_270)
public val Res.string.payroll_bonuses: StringResource by lazy {
      StringResource("string:payroll_bonuses", "payroll_bonuses", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207465, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294297, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189412, 43),
      ))
    }

@delegate:ResourceContentHash(411_333_678)
public val Res.string.payroll_col_planned_hours: StringResource by lazy {
      StringResource("string:payroll_col_planned_hours", "payroll_col_planned_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207505, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294369, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189456, 45),
      ))
    }

@delegate:ResourceContentHash(-652_056_102)
public val Res.string.payroll_col_worked_hours: StringResource by lazy {
      StringResource("string:payroll_col_worked_hours", "payroll_col_worked_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207559, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294435, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189502, 44),
      ))
    }

@delegate:ResourceContentHash(-454_631_206)
public val Res.string.payroll_commutes: StringResource by lazy {
      StringResource("string:payroll_commutes", "payroll_commutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207620, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294500, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189547, 60),
      ))
    }

@delegate:ResourceContentHash(-1_981_176_749)
public val Res.string.payroll_deductions: StringResource by lazy {
      StringResource("string:payroll_deductions", "payroll_deductions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207689, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294613, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189608, 42),
      ))
    }

@delegate:ResourceContentHash(1_998_727_871)
public val Res.string.payroll_disclaimer: StringResource by lazy {
      StringResource("string:payroll_disclaimer", "payroll_disclaimer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 207732, 438),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 294664, 702),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189651, 346),
      ))
    }

@delegate:ResourceContentHash(-1_130_300_154)
public val Res.string.payroll_employee_part: StringResource by lazy {
      StringResource("string:payroll_employee_part", "payroll_employee_part", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208171, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295367, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189998, 57),
      ))
    }

@delegate:ResourceContentHash(-214_335_429)
public val Res.string.payroll_employer_cost: StringResource by lazy {
      StringResource("string:payroll_employer_cost", "payroll_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208304, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295548, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190119, 49),
      ))
    }

@delegate:ResourceContentHash(-2_049_122_093)
public val Res.string.payroll_employer_cost_plan: StringResource by lazy {
      StringResource("string:payroll_employer_cost_plan", "payroll_employer_cost_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208237, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295449, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190056, 62),
      ))
    }

@delegate:ResourceContentHash(-1_599_691_525)
public val Res.string.payroll_employer_part: StringResource by lazy {
      StringResource("string:payroll_employer_part", "payroll_employer_part", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208358, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295630, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190169, 65),
      ))
    }

@delegate:ResourceContentHash(-2_006_584_920)
public val Res.string.payroll_empty: StringResource by lazy {
      StringResource("string:payroll_empty", "payroll_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208436, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295740, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190235, 61),
      ))
    }

@delegate:ResourceContentHash(635_731_975)
public val Res.string.payroll_estimate_title: StringResource by lazy {
      StringResource("string:payroll_estimate_title", "payroll_estimate_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208514, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295842, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190297, 70),
      ))
    }

@delegate:ResourceContentHash(-1_226_377_773)
public val Res.string.payroll_extra_work: StringResource by lazy {
      StringResource("string:payroll_extra_work", "payroll_extra_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208585, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 295941, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190368, 74),
      ))
    }

@delegate:ResourceContentHash(815_765_122)
public val Res.string.payroll_fact_commutes: StringResource by lazy {
      StringResource("string:payroll_fact_commutes", "payroll_fact_commutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208656, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296040, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190443, 65),
      ))
    }

@delegate:ResourceContentHash(97_292_208)
public val Res.string.payroll_fact_ended: StringResource by lazy {
      StringResource("string:payroll_fact_ended", "payroll_fact_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208726, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296150, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190509, 42),
      ))
    }

@delegate:ResourceContentHash(-548_558_127)
public val Res.string.payroll_fact_insured_elsewhere: StringResource by lazy {
      StringResource("string:payroll_fact_insured_elsewhere", "payroll_fact_insured_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208769, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296209, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190552, 62),
      ))
    }

@delegate:ResourceContentHash(934_994_991)
public val Res.string.payroll_fact_long_service: StringResource by lazy {
      StringResource("string:payroll_fact_long_service", "payroll_fact_long_service", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208848, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296320, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190615, 65),
      ))
    }

@delegate:ResourceContentHash(2_073_425_252)
public val Res.string.payroll_fact_off: StringResource by lazy {
      StringResource("string:payroll_fact_off", "payroll_fact_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208914, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296414, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190681, 36),
      ))
    }

@delegate:ResourceContentHash(-328_884_920)
public val Res.string.payroll_fact_on: StringResource by lazy {
      StringResource("string:payroll_fact_on", "payroll_fact_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208951, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296455, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190718, 35),
      ))
    }

@delegate:ResourceContentHash(177_066_289)
public val Res.string.payroll_fact_over50: StringResource by lazy {
      StringResource("string:payroll_fact_over50", "payroll_fact_over50", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 208987, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296495, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190754, 39),
      ))
    }

@delegate:ResourceContentHash(-1_711_551_685)
public val Res.string.payroll_fact_ppk: StringResource by lazy {
      StringResource("string:payroll_fact_ppk", "payroll_fact_ppk", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209100, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296632, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190851, 28),
      ))
    }

@delegate:ResourceContentHash(1_551_451_229)
public val Res.string.payroll_fact_ppk_reduced: StringResource by lazy {
      StringResource("string:payroll_fact_ppk_reduced", "payroll_fact_ppk_reduced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 209035, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 296555, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190794, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString25Resources(map: MutableMap<String, StringResource>) {
  map.put("onboarding_hours_invalid", Res.string.onboarding_hours_invalid)
  map.put("onboarding_hours_later", Res.string.onboarding_hours_later)
  map.put("onboarding_hours_opens", Res.string.onboarding_hours_opens)
  map.put("onboarding_hours_preview", Res.string.onboarding_hours_preview)
  map.put("onboarding_hours_title", Res.string.onboarding_hours_title)
  map.put("onboarding_invite_code_label", Res.string.onboarding_invite_code_label)
  map.put("onboarding_invite_code_placeholder", Res.string.onboarding_invite_code_placeholder)
  map.put("onboarding_join_check", Res.string.onboarding_join_check)
  map.put("onboarding_join_confirm", Res.string.onboarding_join_confirm)
  map.put("onboarding_join_desc", Res.string.onboarding_join_desc)
  map.put("onboarding_join_title", Res.string.onboarding_join_title)
  map.put("onboarding_market", Res.string.onboarding_market)
  map.put("onboarding_market_desc", Res.string.onboarding_market_desc)
  map.put("onboarding_market_poland", Res.string.onboarding_market_poland)
  map.put("onboarding_next", Res.string.onboarding_next)
  map.put("onboarding_review_defaults_desc", Res.string.onboarding_review_defaults_desc)
  map.put("onboarding_review_defaults_title", Res.string.onboarding_review_defaults_title)
  map.put("onboarding_review_edit", Res.string.onboarding_review_edit)
  map.put("onboarding_review_no_sales_plan", Res.string.onboarding_review_no_sales_plan)
  map.put("onboarding_review_settings_hint", Res.string.onboarding_review_settings_hint)
  map.put("onboarding_review_workplace_title", Res.string.onboarding_review_workplace_title)
  map.put("onboarding_role_join", Res.string.onboarding_role_join)
  map.put("onboarding_role_join_desc", Res.string.onboarding_role_join_desc)
  map.put("onboarding_role_owner", Res.string.onboarding_role_owner)
  map.put("onboarding_role_owner_desc", Res.string.onboarding_role_owner_desc)
  map.put("onboarding_role_title", Res.string.onboarding_role_title)
  map.put("onboarding_shift_evening", Res.string.onboarding_shift_evening)
  map.put("onboarding_shift_full_day", Res.string.onboarding_shift_full_day)
  map.put("onboarding_shift_morning", Res.string.onboarding_shift_morning)
  map.put("onboarding_skip", Res.string.onboarding_skip)
  map.put("onboarding_step_business", Res.string.onboarding_step_business)
  map.put("onboarding_step_counter", Res.string.onboarding_step_counter)
  map.put("onboarding_step_done", Res.string.onboarding_step_done)
  map.put("onboarding_step_finance", Res.string.onboarding_step_finance)
  map.put("onboarding_step_hours", Res.string.onboarding_step_hours)
  map.put("onboarding_step_join", Res.string.onboarding_step_join)
  map.put("onboarding_step_role", Res.string.onboarding_step_role)
  map.put("onboarding_step_welcome", Res.string.onboarding_step_welcome)
  map.put("onboarding_step_workplace", Res.string.onboarding_step_workplace)
  map.put("onboarding_summary_plan", Res.string.onboarding_summary_plan)
  map.put("onboarding_summary_shifts", Res.string.onboarding_summary_shifts)
  map.put("onboarding_summary_workplace", Res.string.onboarding_summary_workplace)
  map.put("onboarding_tagline", Res.string.onboarding_tagline)
  map.put("onboarding_welcome_desc", Res.string.onboarding_welcome_desc)
  map.put("onboarding_welcome_point_costs", Res.string.onboarding_welcome_point_costs)
  map.put("onboarding_welcome_point_rosters", Res.string.onboarding_welcome_point_rosters)
  map.put("onboarding_welcome_point_team", Res.string.onboarding_welcome_point_team)
  map.put("onboarding_welcome_title", Res.string.onboarding_welcome_title)
  map.put("onboarding_workplace_desc", Res.string.onboarding_workplace_desc)
  map.put("onboarding_workplace_title", Res.string.onboarding_workplace_title)
  map.put("one_off_cost_add", Res.string.one_off_cost_add)
  map.put("one_off_cost_amount", Res.string.one_off_cost_amount)
  map.put("one_off_cost_day", Res.string.one_off_cost_day)
  map.put("one_off_cost_days_range", Res.string.one_off_cost_days_range)
  map.put("one_off_cost_delete_confirm", Res.string.one_off_cost_delete_confirm)
  map.put("one_off_cost_deleted", Res.string.one_off_cost_deleted)
  map.put("one_off_cost_edit_title", Res.string.one_off_cost_edit_title)
  map.put("one_off_cost_from", Res.string.one_off_cost_from)
  map.put("one_off_cost_name_hint", Res.string.one_off_cost_name_hint)
  map.put("one_off_cost_none", Res.string.one_off_cost_none)
  map.put("one_off_cost_note", Res.string.one_off_cost_note)
  map.put("one_off_cost_period", Res.string.one_off_cost_period)
  map.put("one_off_cost_period_day", Res.string.one_off_cost_period_day)
  map.put("one_off_cost_period_month", Res.string.one_off_cost_period_month)
  map.put("one_off_cost_period_range", Res.string.one_off_cost_period_range)
  map.put("one_off_cost_saved", Res.string.one_off_cost_saved)
  map.put("one_off_cost_spread_hint", Res.string.one_off_cost_spread_hint)
  map.put("one_off_cost_to", Res.string.one_off_cost_to)
  map.put("open_in_new_window", Res.string.open_in_new_window)
  map.put("over_plan_body", Res.string.over_plan_body)
  map.put("over_plan_body_no_bigger", Res.string.over_plan_body_no_bigger)
  map.put("over_plan_renewal", Res.string.over_plan_renewal)
  map.put("over_plan_title", Res.string.over_plan_title)
  map.put("over_plan_upgrade", Res.string.over_plan_upgrade)
  map.put("pay_change_line", Res.string.pay_change_line)
  map.put("pay_change_salaried", Res.string.pay_change_salaried)
  map.put("payroll_below_minimum_hourly", Res.string.payroll_below_minimum_hourly)
  map.put("payroll_benefit_note", Res.string.payroll_benefit_note)
  map.put("payroll_bonuses", Res.string.payroll_bonuses)
  map.put("payroll_col_planned_hours", Res.string.payroll_col_planned_hours)
  map.put("payroll_col_worked_hours", Res.string.payroll_col_worked_hours)
  map.put("payroll_commutes", Res.string.payroll_commutes)
  map.put("payroll_deductions", Res.string.payroll_deductions)
  map.put("payroll_disclaimer", Res.string.payroll_disclaimer)
  map.put("payroll_employee_part", Res.string.payroll_employee_part)
  map.put("payroll_employer_cost", Res.string.payroll_employer_cost)
  map.put("payroll_employer_cost_plan", Res.string.payroll_employer_cost_plan)
  map.put("payroll_employer_part", Res.string.payroll_employer_part)
  map.put("payroll_empty", Res.string.payroll_empty)
  map.put("payroll_estimate_title", Res.string.payroll_estimate_title)
  map.put("payroll_extra_work", Res.string.payroll_extra_work)
  map.put("payroll_fact_commutes", Res.string.payroll_fact_commutes)
  map.put("payroll_fact_ended", Res.string.payroll_fact_ended)
  map.put("payroll_fact_insured_elsewhere", Res.string.payroll_fact_insured_elsewhere)
  map.put("payroll_fact_long_service", Res.string.payroll_fact_long_service)
  map.put("payroll_fact_off", Res.string.payroll_fact_off)
  map.put("payroll_fact_on", Res.string.payroll_fact_on)
  map.put("payroll_fact_over50", Res.string.payroll_fact_over50)
  map.put("payroll_fact_ppk", Res.string.payroll_fact_ppk)
  map.put("payroll_fact_ppk_reduced", Res.string.payroll_fact_ppk_reduced)
}
